<template>
    <b-modal id="shared-modal" size="lg" hide-footer>
        <template #modal-title>
          <div class="pr-5" style="word-break: break-all;">
            <span class="text-info font-weight-bold" style="font-size: 0.95rem;">{{ modalTitle }}</span>
          </div>
        </template>
        <div v-if="!sharedIPs" class="text-center my-4">
             <b-spinner label="Loading..." variant="primary" class="mb-2"></b-spinner>
             <div class="text-muted small">Analyzing shared accounts...</div>
        </div>
        <div v-else>
            <b-alert show variant="info" class="small">
                <i class="fa fa-info-circle"></i> Showing all accounts associated with <strong>{{ modalTitle.split(': ')[1] }}</strong>
            </b-alert>
            <b-table 
                striped 
                hover 
                :items="sharedIPs" 
                :fields="sharedFields"
                show-empty
                sort-by="date"
                :sort-desc="true"
                empty-text="No other accounts found."
            >
                 <template #cell(username)="data">
                    <router-link :to="'/user/' + data.value + '?server=' + server" target="_blank" class="font-weight-bold">
                        {{ data.value }}
                    </router-link>
                    <b-badge v-if="data.item.banned" variant="danger" class="ml-1">
                        {{ data.item.ban_status || 'Banned' }}
                    </b-badge>
                 </template>
                 <template #cell(date)="data">
                     {{ data.value | formatDate }}
                 </template>
            </b-table>
        </div>
    </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
    name: 'SharedAccountsModal',
    data() {
        return {
            modalTitle: 'Shared Accounts',
            server: 'silver',
            sharedFields: [
                { key: 'username', label: 'Username', sortable: true },
                { key: 'count', label: 'Logins', sortable: true },
                { key: 'email', label: 'Email' },
                { key: 'money', label: 'Money', sortable: true, formatter: val => {
                    return val ? val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') : '0'
                }},
                { key: 'date', label: 'Last Seen', sortable: true }
            ]
        }
    },
    computed: {
        ...mapGetters(['sharedIPs'])
    },
    created() {
        this.$root.$on('show-shared-modal', this.show);
    },
    beforeDestroy() {
        this.$root.$off('show-shared-modal', this.show);
    },
    methods: {
        show({ title, server, type, value }) {
            this.$store.commit('setSharedIPs', null);
            this.modalTitle = title || 'Shared Accounts';
            this.server = server || 'silver';
            
            // If data is passed directly (optional, but good for decoupling)
            // For now we rely on Vuex sharedIPs as per existing pattern
            
            this.$bvModal.show('shared-modal');
            
            // Trigger fetch if needed (optional, assuming caller does it)
            // But usually caller emits 'getSharedIPs' then triggers this modal
        }
    },
    filters: {
        formatDate(val) {
            if (!val || val.startsWith('0001') || val.startsWith('0000')) return '-'; 
            return moment(val).format('YYYY-MM-DD HH:mm:ss');
        }
    }
}
</script>
